const SkeletonLoader = () => {
  return (
    <div className="cy:flex cy:gap-8 cy:bg-gray-50 cy:min-h-screen">
      {/* Left Panel - Widget Appearance */}
      <div className="cy:flex-1 cy:bg-white cy:rounded-lg cy:p-6 cy:shadow-sm">
        {/* Header */}
        <div className="cy:mb-6">
          <div className="cy:h-6 cy:bg-gray-200 cy:rounded cy:w-48 cy:mb-2 cy:animate-pulse"></div>
          <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-80 cy:animate-pulse"></div>
        </div>

        {/* Toggle Icon Section */}
        <div className="cy:mb-8">
          <div className="cy:flex cy:items-center cy:gap-2 cy:mb-4">
            <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-24 cy:animate-pulse"></div>
            <div className="cy:w-4 cy:h-4 cy:bg-gray-100 cy:rounded-full cy:animate-pulse"></div>
          </div>
          
          {/* Icon Options Grid */}
          <div className="cy:grid cy:grid-cols-4 cy:gap-4 cy:mb-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className={`cy:p-4 cy:border-2 cy:rounded-lg ${i === 0 ? 'cy:border-blue-300 cy:bg-blue-50' : 'cy:border-gray-200'}`}>
                <div className="cy:w-8 cy:h-8 cy:bg-gray-200 cy:rounded cy:mx-auto cy:mb-2 cy:animate-pulse"></div>
                <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-16 cy:mx-auto cy:animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Icon Size Section */}
        <div className="cy:mb-8">
          <div className="cy:flex cy:items-center cy:justify-between cy:mb-4">
            <div className="cy:flex cy:items-center cy:gap-2">
              <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-20 cy:animate-pulse"></div>
              <div className="cy:w-4 cy:h-4 cy:bg-gray-100 cy:rounded-full cy:animate-pulse"></div>
            </div>
            <div className="cy:h-5 cy:bg-gray-100 cy:rounded cy:w-12 cy:animate-pulse"></div>
          </div>
          <div className="cy:relative">
            <div className="cy:h-2 cy:bg-gray-200 cy:rounded-full cy:animate-pulse"></div>
            <div className="cy:absolute cy:top-0 cy:left-3/4 cy:w-4 cy:h-4 cy:bg-white cy:border-2 cy:border-gray-300 cy:rounded-full cy:-mt-1 cy:animate-pulse"></div>
          </div>
        </div>

        {/* Primary Color Section */}
        <div className="cy:mb-8">
          <div className="cy:flex cy:items-center cy:gap-2 cy:mb-4">
            <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-28 cy:animate-pulse"></div>
            <div className="cy:w-4 cy:h-4 cy:bg-gray-100 cy:rounded-full cy:animate-pulse"></div>
          </div>
          <div className="cy:flex cy:items-center cy:gap-4">
            <div className="cy:w-12 cy:h-10 cy:bg-blue-500 cy:rounded cy:border cy:animate-pulse"></div>
            <div className="cy:flex-1 cy:h-10 cy:bg-gray-100 cy:rounded cy:animate-pulse"></div>
          </div>
        </div>

        {/* Widget Positioning Section */}
        <div className="cy:border-t cy:pt-6">
          <div className="cy:mb-6">
            <div className="cy:h-6 cy:bg-gray-200 cy:rounded cy:w-40 cy:mb-2 cy:animate-pulse"></div>
            <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-72 cy:animate-pulse"></div>
          </div>

          {/* Position Options */}
          <div className="cy:mb-4">
            <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-16 cy:mb-4 cy:animate-pulse"></div>
            <div className="cy:grid cy:grid-cols-2 cy:gap-4">
              {['Top Left', 'Top Right', 'Bottom Left', 'Bottom Right'].map((_, i) => (
                <div key={i} className="cy:flex cy:items-center cy:gap-3">
                  <div className={`w-4 cy:h-4 cy:rounded-full ${i === 3 ? 'cy:bg-blue-500' : 'cy:bg-gray-200'} cy:animate-pulse`}></div>
                  <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-24 cy:animate-pulse"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Live Preview */}
      <div className="cy:w-96 cy:bg-white cy:rounded-lg cy:p-6 cy:shadow-sm">
        {/* Preview Header */}
        <div className="cy:flex cy:items-center cy:gap-2 cy:mb-6">
          <div className="cy:w-5 cy:h-5 cy:bg-gray-200 cy:rounded cy:animate-pulse"></div>
          <div className="cy:h-5 cy:bg-gray-200 cy:rounded cy:w-24 cy:animate-pulse"></div>
        </div>
        <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-56 cy:mb-8 cy:animate-pulse"></div>

        {/* Preview Box */}
        <div className="cy:bg-gray-50 cy:rounded-lg cy:p-8 cy:min-h-[300px] cy:mb-8 cy:relative min-h-48">
          <div className="cy:w-16 cy:h-16 cy:bg-gray-200 cy:rounded cy:mx-auto cy:animate-pulse"></div>
          <div className="cy:h-4 cy:bg-gray-100 cy:rounded cy:w-32 cy:mx-auto cy:mt-4 cy:animate-pulse"></div>
          
          {/* Widget Preview */}
          <div className="cy:absolute cy:bottom-4 cy:right-4 cy:w-12 cy:h-12 cy:bg-blue-500 cy:rounded-full cy:animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;